












































































import Card from '../../../components/material/Card.vue';
import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import DlgEditRecipient from '@/modules/newsletter/_components/DlgEditRecipient.vue';

@Component({
  components: {
    DlgEditRecipient,
    Card,
  },
  filters: {
    date(val: any) {
      if (!val) {
        return '-';
      }
      const date = new Date(val);
      return `${date.getDate()}.${date.getMonth() + 1}.${date.getUTCFullYear()}`;
    },
    datetime(val: any) {
      if (!val) {
        return '-';
      }
      const date = new Date(val);
      let hours = '' + date.getHours();
      hours = ('0' + hours).slice(-2);
      let minutes = '' + date.getMinutes();
      minutes = ('0' + minutes).slice(-2);

      return `${date.getDate()}.${date.getMonth() + 1}.${date.getUTCFullYear()} ${hours}:${minutes}`;
    },
  },
})
export default class NewsletterList extends Vue {
  @Getter('newsletter/all') private newsletter!: any[];
  @Action('newsletter/read') private readNewsletter!: () => any;
  @Getter('members/assorted') private members!: any[];
  @Getter('members/sorted') private membersArray!: any[];
  @Action('members/read') private readMember!: () => any;

  private memberFilter: string | null = null;
  private chkbxActivated: boolean = true;
  private chkbxNotActivated: boolean = true;
  private chkbxBounced: boolean = true;
  private loading: boolean = false;
  private dlgEdit: boolean = false;
  private recipient: any = {};
  private toAllSending: boolean = false;
  private pagination: any = {
    sortBy: 'LAST_MODIFIED_AT_PARSED',
    descending: true,
    rowsPerPage: 25,
  };
  private headers: any[] = [
    {
      text: 'Name',
      align: 'left',
      value: 'name',
    },
    {
      text: 'Email',
      align: 'left',
      value: 'email',
    },
    {
      text: 'Aktiviert',
      align: 'left',
      value: 'activated',
    },
    {
      text: 'Angemeldet am',
      align: 'left',
      value: 'createdAt',
    },
    {
      text: 'Letzte Aktivität',
      align: 'left',
      value: 'modifiedAt',
    },
    {
      text: 'Angeworben durch',
      align: 'left',
      value: 'REFERREDBY',
    },
    {
      text: 'Mitglied/Anderer Grund',
      align: 'left',
      value: 'REFERREDBYREASONNAME',
    },
    {
      text: 'Zuletzt geändert',
      align: 'left',
      value: 'LAST_MODIFIED_AT_PARSED',
    },
    {
      text: '',
      sortable: false,
    },
  ];

  private search: string = '';

  private async created(): Promise<any> {
    this.loading = true;
    await this.readNewsletter();
    await this.readMember();
    this.loading = false;
  }

  get newsletterList() {
    const newsletter: any = [];

    this.newsletter.forEach((recipient) => {
      if (recipient.emailBlacklisted) {
        if (!this.chkbxBounced) {
          return;
        }
      } else {
        if (recipient.activated && !this.chkbxActivated) {
          return;
        }
        if (!recipient.activated && !this.chkbxNotActivated) {
          return;
        }
      }

      if (this.memberFilter && recipient.REFERREDBYREASON !== this.memberFilter) {
        return;
      }

      if (this.members[recipient.REFERREDBYREASON]) {
        recipient.REFERREDBYREASONNAME = this.members[recipient.REFERREDBYREASON].title;
      } else if (recipient.REFERREDBY === 'Anders') {
        recipient.REFERREDBYREASONNAME = recipient.REFERREDBYREASON;
      }

      newsletter.push(recipient);
    });

    return Object.values(newsletter);
  }

  private async editRecipient(recipient: any) {
    this.recipient = recipient;
    this.dlgEdit = true;
  }
}
